import React, { useEffect } from "react";
import "./styles/navbar.css";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "../../utils/UserContext";
import Logo from "../../assets/logotipo - alfa tabelas.png";
import { logout } from "../../services/api/logout";
import {
  FaHome,
  FaUserCheck,
  FaRegCreditCard,
  FaUserCircle,
  FaHospitalUser,
} from "react-icons/fa";
import { MdRealEstateAgent, MdNewReleases } from "react-icons/md";
import { IoMdAdd, IoIosExit, IoLogoWhatsapp } from "react-icons/io";

export default function Navbar({ menuOpen, closeMenu }) {
  const location = useLocation();
  const { currentUser, isLoading } = useUser();

  useEffect(() => {
    closeMenu();
  }, [location]);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const userLevel = currentUser?.nivel || "";

  return (
    <>
      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      <nav className={menuOpen ? "nav-open" : ""}>
        <Link to="/dashboard/" className="container-logotipo">
          <img src={Logo} alt="Alfa Tabelas - Logotipo" />
        </Link>

        {isLoading ? (
          <div className="navbar-container-data-user">
            <p>Carregando...</p>
          </div>
        ) : currentUser ? (
          <div className="navbar-container-data-user">
            <i>
              <FaUserCircle />
            </i>
            <div className="user-details-wrapper">
              <div className="navbar-field-data">
                <p>USUÁRIO: </p>
                <p>{currentUser.nome.toUpperCase()}</p>
              </div>
              <div className="navbar-field-data">
                <p>NÍVEL:</p>
                <p>{userLevel.toUpperCase()}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="navbar-container-data-user">
            <p>Usuário não encontrado.</p>
          </div>
        )}

        <ul className="navbar-paths">
          <li className={location.pathname === "/dashboard/" ? "active" : ""}>
            <Link to="/dashboard/" className="custom-link">
              <i>
                <FaHome />
              </i>
              <span>Todos os imóveis</span>
            </Link>
          </li>
          {(userLevel.toLowerCase() === "administrador" ||
            userLevel.toLowerCase() === "assistente") && (
            <>
              <li
                className={
                  location.pathname === "/dashboard/adicionar-imovel"
                    ? "active"
                    : ""
                }
              >
                <Link to="/dashboard/adicionar-imovel" className="custom-link">
                  <i>
                    <IoMdAdd />
                  </i>
                  <span>Adicionar Imóvel</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/dashboard/liberacao" ? "active" : ""
                }
              >
                <Link to="/dashboard/liberacao" className="custom-link">
                  <i>
                    <MdNewReleases />
                  </i>
                  <span>Liberação de Imóveis</span>
                </Link>
              </li>
            </>
          )}
          <li
            className={
              location.pathname === "/dashboard/imoveis" ? "active" : ""
            }
          >
            <Link to="/dashboard/imoveis" className="custom-link">
              <i>
                <MdRealEstateAgent />
              </i>
              <span>Filtrar imóveis</span>
            </Link>
          </li>
          {userLevel.toLowerCase() === "administrador" && (
            <li
              className={
                location.pathname === "/dashboard/entidades" ? "active" : ""
              }
            >
              <Link to="/dashboard/entidades" className="custom-link">
                <i>
                  <FaHospitalUser />
                </i>
                <span>Responsáveis</span>
              </Link>
            </li>
          )}
          {userLevel.toLowerCase() === "administrador" && (
            <li
              className={
                location.pathname === "/dashboard/usuarios" ? "active" : ""
              }
            >
              <Link to="/dashboard/usuarios" className="custom-link">
                <i>
                  <FaUserCheck />
                </i>
                <span>Usuários</span>
              </Link>
            </li>
          )}
          {userLevel.toLowerCase() !== "assistente" && (
            <li
              className={
                location.pathname === "/dashboard/pagamentos" ? "active" : ""
              }
            >
              <Link to="/dashboard/pagamentos" className="custom-link">
                <i>
                  <FaRegCreditCard />
                </i>
                <span>Pagamentos</span>
              </Link>
            </li>
          )}
        </ul>

        <div className="navbar-access">
          <a
            href="https://api.whatsapp.com/send?phone=5513996025791"
            target="_blank"
            rel="noreferrer"
          >
            <i>
              <IoLogoWhatsapp />
            </i>
            <span>Solicitar Suporte</span>
          </a>
          <button onClick={logout}>
            <i>
              <IoIosExit />
            </i>
            <span>Sair da plataforma</span>
          </button>
        </div>
      </nav>
    </>
  );
}